<template>
  <div class='container-xl container-fluid'>
    <h1>Test Page</h1>

    <button v-on:click="this.do_something">Do Something</button>
    <button v-on:click="testMoney">Test Money</button>
    <button v-on:click="roulette">RouletteAuthoraize</button>
    <button v-on:click="rouletteResult">RouletteResult</button>
    <button
      v-on:click="openSidePanel"
      style="background-color: #3b82f6; border: none; padding: 8px 16px; border-radius: 6px; color: white; cursor: pointer; margin-left: 10px;"
    >
      Тест боковой панели
    </button>


    <!-- msform fields test -->
    <div class="content p-4 mt-3">
      <h3>msform Fields (Form #{{ formCode }})</h3>
      <div class="d-flex align-items-center gap12 mb-3">
        <InputSimple
          id="formCode"
          :dataValue="formCode"
          @updateParentState="updateFormCode"
          placeholder="Form code"
          style="width: 120px;"
        />
        <button v-on:click="loadMsFormFields" :disabled="msformLoading">
          {{ msformLoading ? 'Loading...' : 'Load Form Fields' }}
        </button>
      </div>
      <div v-if="msformError" class="mt-2" style="color: red;">{{ msformError }}</div>
      <div v-if="msformFields && msformFields.length > 0" class="mt-3">
        <GetInputs
          :fields="msformFields"
          :onAlias="true"
          :dataValues="msformValues"
          @updateParentState="setMsformValue"
        />
      </div>
      <div v-else-if="!msformLoading && !msformError" class="mt-2" style="color: #666;">
        Click "Load Form Fields" to fetch fields from msform microservice
      </div>
    </div>


    <div class="content p-4 mt-3">
      <button v-on:click="downloadPDF">Download PDF</button>
      <button v-on:click="ceckNotify">Check Notify</button>
      <button v-on:click="ratesSetup">Rates Setup</button>
    </div>

    <div class="content p-4 mt-3">
      <button v-on:click="GetProtocolsList">GetProtocolsList</button>
      <button v-on:click="getInfo">Get Info</button>
    </div>

  </div>
</template>

<script>
import GetInputs from "@/components/service/GetInputs";
import InputSimple from "@/components/service/InputSimple";


export default {
    components: {
      GetInputs,
      InputSimple
    },
    data() {
      return {
        // Legacy fields values
        pdf: {
          title: 'PDF Title',
          content: [
            {
              param1: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.SDAAAAAAAAAAAAAAAAAAAAAAAAAadasdasanajan dbnajdbasdbasdbasdbas abdkasbdasdbadajdajdbafbahkdbadbajdadgbkbgdfughsuhdfufhsaufhaaiofhaiofhsadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfu',
              param2: 'value2',
              param3: 'value3'
            },
            {
              param4: 'value4',
              param5: 'value5',
              param6: 'value6'
            },
          ],
          end: {
            param7: 'value7',
          }
        },
        // msform fields state
        formCode: 1,
        msformFields: [],
        msformValues: {},
        msformLoading: false,
        msformError: null
      }
    },
    mounted() {
      // Auto-load msform fields on page load
      this.loadMsFormFields();
    },
    methods: {
        do_something() {
          this.axios.post('DoSomething', {data: {cmd: 'free_report'}})
        },
        setValue(arg) {
          this.fields_values[arg.id] = arg.value;
        },
        setMsformValue(arg) {
          this.msformValues[arg.id] = arg.value;
        },
        updateFormCode(arg) {
          this.formCode = arg.value;
        },
        /**
         * Load form fields from msform microservice
         */
        loadMsFormFields() {
          this.msformLoading = true;
          this.msformError = null;

          this.axios.post('GetPublicFormFields', { data: { code: this.formCode } })
            .then(res => {
              // Response is wrapped in body by PHP backend
              const data = res.data.body || res.data;
              if (data.result === 0 && data.tables && data.tables.fields) {
                this.msformFields = data.tables.fields.colvalues || [];
                // Initialize values for each field
                this.msformValues = {};
                this.msformFields.forEach(field => {
                  this.msformValues[field.alias] = field.default_value || '';
                });
              } else {
                this.msformError = data.result_text || 'Failed to load form fields';
              }
            })
            .catch(err => {
              this.msformError = err.message || 'Network error';
              console.error('Failed to load msform fields:', err);
            })
            .finally(() => {
              this.msformLoading = false;
            });
        },
        ceckNotify() {
          this.axios.post('GetDestinations')
        },
        testMoney() {
          this.$store.commit('MODAL', {
            action: true,
            content: {
              width: 608,
              title: 'Test'
            },
            type: 'TestMoney',
          });
        },
        roulette() {
          // DELTA: disabled
          // this.axios.post('RouletteAuthoraize', {member: true});
        },
        rouletteResult() {
          // DELTA: disabled
          // this.axios.post('SendRouletteResult', {member: true, data: {gift_amount: 1000}});
        },
        ratesSetup() {
          this.axios.post('GetRatesSetup');
        },
        downloadPDF() {
          // Создаем форму для отправки GET запроса в новом окне
          const form = document.createElement('form');
          form.method = 'GET';
          form.action = '/DownloadPDF';
          form.target = '_blank';

          // Добавляем JSON данные как скрытое поле
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'data';
          input.value = JSON.stringify(this.pdf);
          form.appendChild(input);

          // Добавляем форму в DOM, отправляем и удаляем
          document.body.appendChild(form);
          form.submit();
          document.body.removeChild(form);
        },
        openSidePanel() {
          this.$store.commit('SIDE_PANEL_SHOW', {
            title: '',
            content: {
              component: 'AMLCheck',
              props: {}
            }
          });
        },
        GetProtocolsList() {
          this.axios.post('GetProtocolsList');
        },
        getInfo() {
          this.axios.post('GetInfo');
        },

    }
}
</script>
<style lang="scss" scoped>
  div {
    margin-top: 10px;
  }
</style>
